export default "__VITE_ASSET__b8bf87ea__"